import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

/**
 * Loads translation files from `src/assets/i18n`.
 *
 * IMPORTANT: this is built on HttpBackend, not HttpClient.
 *
 * `PathInterceptorService` rewrites the URL of every outgoing HttpClient request
 * to `environment.apiUrl + request.url`. Translation files are static assets served
 * from the Angular app's own origin, so going through the interceptor chain would
 * turn `assets/i18n/en.json` into a cross-origin call against the .NET API and 404.
 * HttpBackend dispatches straight to the browser, skipping all interceptors.
 *
 * This also means translation requests carry no Authorization header, which is
 * correct — the login screen must be translatable before the user has a token.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = new HttpClient(inject(HttpBackend));

  /**
   * @param path `en` for the root scope, or `public/en` for a lazy-loaded scope.
   */
  public getTranslation(path: string): Observable<Translation> {
    return this.http.get<Translation>(`/assets/i18n/${path}.json`);
  }
}
